export const APPOINTMENT_DETAILS_LISTING_COLUMNS = [
  {
    id: "appointmentId",
    label: "Appointment Id",
  },
  
  {
    id: "appointmentDate",
    label: "Appointment Date",
  },
  {
    id: "appointmentStartTime",
    label: "Start Time",
  },
  {
    id: "vendorCode",
    label: "Vendor Code",
  },
  {
    id: "fcCode",
    label: "Site",
  },
  {
    id: "dockName",
    label: "Dock Name",
  },
  // {
  //   id: "fcName",
  //   label: "WH Name",
  // },

  { id: "po", label: "PO / ASN" },
  {
    id: "status",
    label: "Status",
  },
  {
    id: "action",
    label: "Action",
  },
];

export const APPOINTMENT_DETAILS_LIST = [
  {
    id: "vendorCode",
    label: "Vendor Code",
  },
  {
    id: "vendorName",
    label: "Vendor Name",
  },
  {
    id: "asn",
    label: "ASN",
  },
  {
    id: "poNumber",
    label: "PO",
  },
  {
    id: "gstin",
    label: "GSTIN",
  },
  {
    id: "ibDockId",
    label: "IB Dock",
  },
  {
    id: "noOfCases",
    label: "No Of Cases",
  },
  {
    id: "countOfSkus",
    label: "Count Of Skus",
  },
  {
    id: "fcName",
    label: "Destination FC",
  },

  {
    id: "appointmentDate",
    label: "Appointment Date",
  },
  {
    id: "appointmentStartTime",
    label: "Appointment Time",
  },
  {
    id: "incomingMaterial",
    label: "Type Of Incoming Material",
  },
  {
    id: "vehicleType",
    label: "vehicle Type",
  },
  { id: "countOfVehicle", label: "Count Of Vehicle" },
  {
    id: "vehicleRegistrationNumber",
    label: "Vehicle Registration Number",
  },
  {
    id: "driverName",
    label: "Driver Name",
  },
  {
    id: "driverContactNumber",
    label: "Driver Contact Number",
  },
  {
    id: "status",
    label: "Status",
  },
];
export const AddFcListColoum = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "FC Name",
  },
  {
    id: "calories",
    numeric: false,
    disablePadding: false,
    label: "Application No",
  },

  {
    id: "protein",
    numeric: false,
    disablePadding: false,
    label: "Date of Birth",
  },
];

export const BULK_APPOINTMENT_LISTING_COLUMNS = [
  {
    id: "requestId",
    label: "Request Id",
  },
  {
    id: "totalUploadedRecords",
    label: "Total Records",
  },
  {
    id: "statusContent",
    label: "Status",
  },
  {
    id: "uploadedDate",
    label: "Uploaded Date",
  },

  {
    id: "uploadedBy",
    label: "Uploaded By",
  },
  {
    id: "details",
    label: "Details",
  },
];
export const OnboardingStatusMap = {
  STATUS_APPROVED: 0,
  STATUS_PENDING: 1,
  STATUS_DRAFT: 2,
  STATUS_REJECT: 3,
  STATUS_PROCESSING: 4,
  STATUS_INCOMPLETE: 5,
  STATUS_TERMINATED: 6,
  STATUS_FAILED: 7,
  STATUS_VALIDATION_COMPLETED: 8,
};
export const SUCCESS_BULK_LISTING_COLUMNS = [
  {
    id: "appointmentId",
    label: "Appointment ID",
  },
  {
    id: "fcCode",
    label: "FC Code",
  },

  {
    id: "fcName",
    label: "FC Name",
  },

  { id: "appointmentDate", label: "Appointment Date" },
  { id: "appointmentStartTime", label: "Appointment Start Time" },

  {
    id: "appointmentEndTime",
    label: "Appointment End Time",
  },
  {
    id: "po",
    label: "PO",
  },
  { id: "remark", label: "Remark" },
];
export const FAILED_BULK_LISTING_COLUMNS = [
  { id: "appointmentDate", label: "Appointment Date" },
  {
    id: "po",
    label: "PO",
  },
  { id: "remark", label: "Remark" },
];

export const BULK_UPLOAD_TEMPLATE_SAMPLE_COLUMN_LISTING = [
  { id: "appointmenDate", label: "APPOINTMENT_DATE" },
  { id: "poNumber", label: "PO_NUMBER" },
  { id: "gstin", label: "GSTIN" },
  { id: "numberOfCases", label: "NUMBER_OF_CASES" },
  { id: "countOfSkus", label: "COUNT_OF_SKUS" },
  { id: "materialType", label: "MATERIAL_TYPE_ID" },
  { id: "vehicleType", label: "VEHICLE_TYPE_ID" },
  { id: "vrn", label: "VRN" },
  { id: "driverName", label: "DRIVER_NAME" },
  { id: "driverContactNumber", label: "DRIVER_CONTACT_NUMBER" },
];
